import axiosClient from '../../../../networks/apiClient';
import useSWR from 'swr';
import { Case } from '../../../Cases/hooks/useGetCases/types';
import { CaseProgressElement } from '../../../CaseProgress/hooks/useGetCaseProgress/types';

export interface ProgressCriterionItem {
  id: string;
  shortId: string;
  name: string;
  groupName: string | null;
  active: boolean;
}

export interface ProgressCriterion {
  kind: string;
  label: string;
  values: string[];
  items: ProgressCriterionItem[];
}

export interface CaseProgressDetail {
  element: CaseProgressElement;
  description: string;
  criteria: ProgressCriterion[];
  accomplishedItems: number;
  caseCount: number;
  cases: Case[];
}

const useGetCaseProgressDetail = (code: string | undefined) => {
  const { data, isLoading, error } = useSWR(
    code ? `/cases/progress/${code}` : null,
    async (): Promise<CaseProgressDetail> => {
      const response = await axiosClient.get(`/cases/progress/${code}`);
      return response.data.data;
    },
  );

  return { detail: data, loading: isLoading, error };
};

export default useGetCaseProgressDetail;
